<template>
    <f7-block class="requisite-page_requisite-target-types mt-0 mb-6">
        <requisite-page-target-type
	        v-for="target in targetTypes"
	        :key="target.type"
	        :title="target.title"
	        :description="target.description"
	        :is-active="requisite && !requisite.isNew() ? requisite?.psystem?.targetType === target.type : target.type === controller.selectedPSystemTargetType.value"
	        :is-disabled="requisite && !requisite.isNew() ? requisite?.psystem?.targetType !== target.type : false"
	        @click="handleSelectRequisiteType(target.type)"
        />
    </f7-block>
</template>

<script setup lang="ts">
import RequisitePageTargetType from "@/views/requisites-group/requisite/components/RequisitePageTargetType.vue";
import {RequisitePsystemTargetType} from "@enums/RequisitePsystemTargetType";
import RequisitePageController from "@/views/requisites-group/requisite/RequisitePageController";
import {useTranslate} from "@tolgee/vue";
import Requisite from "@models/requisite/Requisite";

const {t} = useTranslate();
const controller = RequisitePageController.of();

const {
	requisite,
	selectedPSystemTargetType
} = controller

const targetTypes = [
	{
		type: RequisitePsystemTargetType.P2P,
		title: t.value("requisite.target-types.p2p.title"),
		description: t.value("requisite.target-types.p2p.text"),
	},
	{
		type: RequisitePsystemTargetType.WALLET,
		title: t.value("requisite.target-types.wallet.title"),
		description: t.value("requisite.target-types.wallet.text"),
	}
]

const handleSelectRequisiteType = (type: RequisitePsystemTargetType) => {
	if (!requisite.value?.isNew()) return;

	if (type === RequisitePsystemTargetType.P2P) {
		requisite.value = Requisite.build(
			controller.getPsystemByTargetType(RequisitePsystemTargetType.P2P)
		);
	} else {
		requisite.value = Requisite.build(
			controller.getPsystemByTargetType(RequisitePsystemTargetType.WALLET)
		);
	}

	controller.selectedPSystemTargetType = type;
}
</script>

<style scoped lang="scss">
.requisite-page_requisite-target-types {
    margin-top: 24px;
    display: flex;
    gap: 12px;
}
</style>
